import React from 'react';
import './Checkbox.css';

interface CheckboxProps {
  label: string;
  id: string;
  formik: any;
  additionalClasses?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, id, formik }) => {
  return (
    <label className="ui-widget-checkbox">
      <input
        type="checkbox"
        checked={formik.values[id]}
        onChange={() => formik.setFieldValue(id, !formik.values[id])}
        id={id}
      />
      <span>{label}</span>
    </label>
  );
};

export default Checkbox;
